import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-password-complexity-check',
  templateUrl: './password-complexity-check.component.html',
  styleUrls: ['./password-complexity-check.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordComplexityCheckComponent {
  @Input() public control: FormControl;
}
